<template>
  <div
    class=""
    :class="
      isShowWenKU
        ? 'header newfix whitebg'
        : isshouye
        ? 'header newfix'
        : 'header'
    "
  >
    <!-- <ul class="nav">
      <li class="navitem">
        <el-dropdown class="icons" placement="bottom">
          <button @click.stop="toPath('/')">
            <img src="/static/newhome/icon/home.png" class="buttonImg" />
          </button>
          <el-dropdown-menu slot="dropdown">
            <a @click.stop="toPath('/')"
              ><el-dropdown-item>首頁</el-dropdown-item></a
            >
          </el-dropdown-menu>
        </el-dropdown>
      </li>
      <li class="navitem">
        <el-dropdown class="icons" placement="bottom">
          <button @click.stop="toPath('/')">
            <img src="/static/newhome/icon/user.png" class="buttonImg" />
          </button>
          <el-dropdown-menu slot="dropdown">
            <a @click.stop="toPath('/')"
              ><el-dropdown-item>注册登录</el-dropdown-item></a
            >
          </el-dropdown-menu>
        </el-dropdown>
      </li>
      <li class="navitem">
        <el-dropdown class="icons" placement="bottom">
          <button @click.stop="toPath('/wenku')">
            <img src="/static/newhome/icon/yuanliu.png" class="buttonImg" />
          </button>
          <el-dropdown-menu slot="dropdown">
            <a @click.stop="toPath('/wenku')"
              ><el-dropdown-item>文库源流</el-dropdown-item></a
            >
          </el-dropdown-menu>
        </el-dropdown>
      </li>
      <li class="navitem">
        <el-dropdown class="icons" placement="bottom">
          <button @click.stop="toPath('/')">
            <img src="/static/newhome/icon/cangshu.png" class="buttonImg" />
          </button>
          <el-dropdown-menu slot="dropdown">
            <a @click.stop="toPath('/')"
              ><el-dropdown-item>藏书汇览</el-dropdown-item></a
            >
          </el-dropdown-menu>
        </el-dropdown>
      </li>
    </ul> -->
    <ul class="nav">
      <li class="navitem">
        <img src="/static/newhome/icon/home.png" class="buttonImg" />
        <p class="fontstyle">首頁</p>
      </li>
      <li class="navitem" @click.stop="toPath('/wenku')">
        <img src="/static/newhome/icon/yuanliu.png" class="buttonImg" />
        <p class="fontstyle">文庫源流</p>
      </li>
      <li class="navitem" @click.stop="toPath('/result')">
        <img src="/static/newhome/icon/cangshu.png" class="buttonImg" />
        <p class="fontstyle">藏書匯覽</p>
      </li>
      <li v-if="!isLogin" class="navitem" @click.stop="toPath('/login')">
        <img src="/static/newhome/icon/user.png" class="buttonImg" />
        <p class="fontstyle">注冊登錄</p>
      </li>
      <li v-if="isLogin" class="navitem" @click.stop="toPath('/personal')">
        <img src="/static/newhome/icon/user.png" class="buttonImg" />
        <p class="fontstyle">個人中心</p>
      </li>
    </ul>
  </div>
</template>

<script>
import eventBus from '@/utils/eventBus.js'
import "animate.css"
export default {
  name: 'NewHeader',
  data () {
    return {
      isshouye: false,
      isLogin: false,
      // isshow: true,
    }
  },
  // props: {
  //   isshow: true
  // },
  props: {
    // transheight: 0,
    isshow: true,
    isShowWenKU: false

  },
  mounted () {
    this.isLogin = localStorage.getItem('token') ? true : false
    eventBus.$on('outLogin', (type) => {
      this.isLogin = localStorage.getItem('token') ? true : false
    })
    // window.addEventListener('scroll', this.menufloat)
    if (this.$route.name == 'NewHome') {
      this.isshouye = true
    }
    // setTimeout(() => {
    //   this.isshow = false
    // }, 1000)
    // setTimeout(() => {
    //   this.isshow = true
    // }, 1000)


  },
  methods: {
    toPath (path) {
      this.$router.push({
        path: path
      })
    },
    // menufloat (e) {
    //   const n = document.documentElement.scrollTop
    //   if (n > 0) {

    //     this.isShowWenKU = true
    //     // this.isshow = true
    //     // setTimeout(() => {
    //     //   this.isshow = true
    //     // }, 500)
    //   } else {

    //     this.isShowWenKU = false
    //     // this.isshow = false
    //     // setTimeout(() => {
    //     //   this.isshow = false
    //     // }, 500)

    //   }

    // }
  }

}
</script>

<style lang="less" scoped>
.whitebg {
  background-color: #fff;
}
.newfix {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}
/deep/.el-dropdown-menu {
  padding: 0px;
}
// .ele-enter,
// .ele-leave-to {
//   transform: translateY(-100%);
// }
// .ele-enter-to,
// .ele-leave {
//   transform: translateY(0);
// }
button {
  border: 1px solid transparent;
  outline: none;
  background-color: transparent;
}

.header {
  width: 100%;
  height: 100px;
  // transition: all 1s linear;
  font-size: 16px;
  // position: fixed;
  padding: 32px 113px;
  // line-height: 100px;
  z-index: 9999;
  .nav {
    width: 100%;
    height: 32px;

    display: flex;
    justify-content: flex-end;
    align-content: center;
    .navitem {
      cursor: pointer;
      margin-left: 40px;
      text-align: center; //新增

      img {
        height: 24px;
        width: auto;
      }
      p {
        margin: 0;
        padding: 0;
      }
      .fontstyle {
        margin-top: 2px;
        color: #fff;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/newheader.vue